<template>
  <div>
    <b-row
      v-for="(preset, ix) in DISTANCE_PRESETS"
      :key="ix"
      class="my-1"
    >
      <b-col
        md="4"
        class="d-flex align-items-center"
      >
        <h5>{{ preset.label }}</h5>
      </b-col>
      <b-col
        md="8"
      >
        <b-spinner
          v-if="preset.loading"
          variant="primary"
          small
        />
        <template v-else>
          <b-row>
            <b-col md="4">
              <span><strong>Fare:</strong> {{ preset.fare }}</span>
            </b-col>
            <b-col md="4">
              <span><strong>Distance:</strong> {{ preset.distanceValue }}</span>
            </b-col>
            <b-col md="4">
              <span><strong>Time:</strong> {{ preset.timeValue }}</span>
            </b-col>
          </b-row>
        </template>
      </b-col>
    </b-row>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import {
  BRow, BCol, BSpinner,
} from 'bootstrap-vue'
import { reactive, ref } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    // BButton,
    BSpinner,
    BRow,
    BCol,
  },
  props: {
    service: {
      type: String,
      required: true,
    },
    versionSettings: {
      type: Object,
      default: () => {},
    },
    currentZone: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    const DISTANCE_PRESETS = ref([
      {
        label: 'KM 3.6 دوار عبدون - Bustanji',
        value: 3.6,
        loading: false,
        fare: 0,
        distanceValue: 0,
        timeValue: 0,
        timeValuePreset: 10,
      },
      {
        label: 'KM 5.4 العبدلي مول - Bustanji',
        value: 5.4,
        loading: false,
        fare: 0,
        distanceValue: 0,
        timeValue: 0,
        timeValuePreset: 15,
      },
      {
        label: 'KM 7.4 دوار خلدا - Bustanji',
        value: 7.4,
        loading: false,
        fare: 0,
        timeValue: 0,
        timeValuePreset: 15,
        distanceValue: 0,
      },
      {
        label: 'KM 9 جامعة الأميرة سمية - Bustanji',
        value: 9,
        loading: false,
        fare: 0,
        distanceValue: 0,
        timeValue: 0,
        timeValuePreset: 24,
      },
      {
        label: 'KM 10 مسجد نابلس - Bustanji',
        value: 10,
        loading: false,
        fare: 0,
        distanceValue: 0,
        timeValue: 0,
        timeValuePreset: 20,
      },
      {
        label: 'KM 12 حديقة المقابلين - Bustanji',
        value: 12,
        loading: false,
        fare: 0,
        distanceValue: 0,
        timeValue: 0,
        timeValuePreset: 27,
      },
    ])
    const version = reactive({
      drop_zone: props.currentZone,
      total_arrival_wait_time: 0,
      total_time: null,
      total_distance: null,
      create_time: new Date(),
    })
    const calculatingEstimate = ref(false)
    const calcEstimate = async distancePreset => {
      try {
        distancePreset.loading = true

        const temp = {
          ...version,
          total_arrival_wait_time: +version.total_arrival_wait_time * 60,
          total_time: distancePreset.timeValuePreset * 60,
          total_distance: distancePreset.value,
          drop_zone: props.currentZone,
        }
        // Convert to seconds
        const versionSettingsTemp = { ...props.versionSettings }
        versionSettingsTemp.upfront_estimates = { ...props.versionSettings.upfront_estimates }
        versionSettingsTemp.upfront_estimates.time = { ...props.versionSettings.upfront_estimates.time }
        if (props.versionSettings.upfront_estimates.active && props.versionSettings.upfront_estimates.time.rate === 'fixed') {
          versionSettingsTemp.upfront_estimates.time.maximum *= 60
          versionSettingsTemp.upfront_estimates.time.minimum *= 60
        }

        const response = await ctx.root.$store.dispatch('versions/testVersion', {
          settings: versionSettingsTemp,
          inputs: temp,
        })
        const { fare } = response.data.data
        distancePreset.fare = fare.total.toFixed(2)
        distancePreset.distanceValue = fare?.details?.distance_slicings?.amount ? `${fare?.details?.distance_slicings?.amount} JOD` : '-'
        distancePreset.timeValue = fare?.details?.time_slicings?.amount ? `${fare?.details?.time_slicings?.amount} JOD` : '-'
      } finally {
        distancePreset.loading = false
      }
    }

    const applyTests = async () => {
      const requests = DISTANCE_PRESETS.value.map(d => calcEstimate(d))
      try {
        await Promise.all(requests)
      } catch (error) {
        errorNotification('An Error occured while fetching test presets')
      }
    }

    // applyTests()

    return {
      applyTests,
      calcEstimate,
      calculatingEstimate,
      DISTANCE_PRESETS,
    }
  },
}
</script>

<style scoped>
</style>
